export default "__VITE_ASSET__DHACIgvG__"